import * as Yup from "yup";

export const DEVICE_TYPE = {
  GPS: "GPS",
  Wifi: "Wifi",
  // Beacon: "Beacon",
  // Fingerprint: "Fingerprint",
};

export const initialValues = {
  accumulateName: null,
  accumulateNameEn: null,
  incomeDeductionId: null,
};

const YearAccumulateSchema = Yup.object().shape({
  accumulateName: Yup.string().required("Please select."),
  accumulateNameEn: Yup.string().required("Please enter."),
  incomeDeductionId: Yup.string().required("Please enter."),
});

export default YearAccumulateSchema;
